<app-app-holder>
    <app-navbar></app-navbar>

    <app-sidebar>
        <div class="sidebar-spacing">
            <h3>Timesheets</h3>
            <small>Views</small>
        </div>

        <span class="divider divider--small"></span>
        <nav class="app__subnav">
            <a
                (click)="byEmployeeSelected()"
                [ngClass]="{ app__subnav__active: sortedByEmployee }">
                <span class="w-100">Timesheets</span>
            </a>
            <a
                (click)="byProjectSelected()"
                [ngClass]="{ app__subnav__active: sortedByProject }">
                <span class="w-100">Send invoices</span>
            </a>
        </nav>
    </app-sidebar>

    <app-content>
        <div class="app__title">
            <h1>
                {{ selectedDate$ | async | date: 'MMMM yyyy' }}
                <span *ngIf="timesheets$ | async as timesheets">({{ timesheets.length }} timesheets)</span>
            </h1>
            <span>
                <button class="button button--primary" id="spacer" (click)="importFromJiraForSelectedMonth()">
                    Import all Tempo timesheets for {{ selectedDate$ | async | date: 'MMMM yyyy' }}
                </button>
            </span>
            <span>
                <button class="button" (click)="openSdworxUploadModal()" style="margin-right:12px;">
                    <i class="las la-upload" style="margin-right:6px;"></i>
                    Upload SDWorx urenrapport
                </button>
            </span>
            <span>
                <button class="button m-r-2" style="margin-left:12px;" (click)="refresh()">Refresh</button>
            </span>
            <span>
                <button class="button button--icon m-r-1" (click)="moveDate(-1)">
                    <i class="las la-arrow-left"></i>
                </button>
                <button class="button m-r-1" (click)="moveDate(0)">
                    Last month
                </button>
                <button class="button button--icon" (click)="moveDate(1)">
                    <i class="las la-arrow-right"></i>
                </button>
            </span>
        </div>

        <div *ngIf="!isLoading">
            <span *appIsPermitted="{
                    module: 'TIMESHEETS',
                    operator: 'AND',
                    actions: ['READ']
                }">
                <div *ngIf="timesheets$ | async as timesheets; else loading">
                    <div *ngIf="timesheets && timesheets.length > 0; else empty">
                        <app-timesheets-list *ngIf="sortedByEmployee">
                        </app-timesheets-list>
                        <div *ngIf="sortedByProject" class="timesheets-filter-toggle m-b-2">
                            <span class="timesheets-filter-toggle__label">Toon:</span>
                            <div class="timesheets-filter-toggle__buttons">
                                <button
                                    type="button"
                                    class="button button--small"
                                    [class.is-active]="!showOnlyDoneTimesheets"
                                    (click)="setShowOnlyDoneTimesheets(false)">
                                    Alle timesheets
                                </button>
                                <button
                                    type="button"
                                    class="button button--small"
                                    [class.is-active]="showOnlyDoneTimesheets"
                                    (click)="setShowOnlyDoneTimesheets(true)">
                                    Enkel gevalideerde timesheets (DONE)
                                </button>
                            </div>
                        </div>
                        <div *ngIf="sortedByProject && hasTimesheetsNotDone()" class="send-invoices-warning m-b-3">
                            Niet alle timesheets zijn approved
                        </div>
                        <app-timesheets-project-list *ngIf="sortedByProject" [showOnlyDoneTimesheets]="showOnlyDoneTimesheets">
                        </app-timesheets-project-list>
                    </div>
                </div>
            </span>

        </div>
        <app-loading-message *ngIf="isLoading"></app-loading-message>
    </app-content>

    <ng-template #empty>
        <app-message-empty [title]="'No Timesheets...'"
            [subtitle]="'Timesheets let you register you employees\'s working hours'"
            [icon]="'../../assets/img/open-box.png'">
            <a (click)="addNewTimesheet()" class="button button--primary" *appIsPermitted="{
                    module: 'TIMESHEETS',
                    operator: 'AND',
                    actions: ['CREATE']
                }">Add a Timesheet</a>
        </app-message-empty>
    </ng-template>
</app-app-holder>